import { IUser } from '@epicuro-next/data/users';

export const usersToUserEntities = (users: IUser[]): IUser[] =>
  users.map((user) => ({
    ...user,
    userExternalId: user.externalId,
  }));
